var map = {
	"./WaveBLUE.jpg": 8718,
	"./Wavey.jpg": 153,
	"./asu_logo.png": 5250,
	"./dfci_logo.png": 7396,
	"./garmin_logo.png": 3240,
	"./google_logo.png": 3355,
	"./icons8-y-64.png": 6683,
	"./jmir_logo.png": 6817,
	"./jour_gero_logo.png": 3879,
	"./life365_logo.png": 6267,
	"./link_icon.jpg": 4356,
	"./me.png": 6635,
	"./me_2.png": 2454,
	"./me_laugh.png": 1288,
	"./msft_logo.png": 7010,
	"./onsemi_logo.png": 7305,
	"./pfr_logo.png": 4303,
	"./refugee_tracker_logo.png": 1000,
	"./rmel_logo.png": 8210,
	"./soda_logo.png": 5447,
	"./sunlang_logo.png": 997,
	"./tyrocode_logo.png": 8924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;